import storageService from './storageService'

export const storageAccessToken = storageService('accessToken')
